export default __webpack_public_path__ + "img/back-button.50450281.svg";